var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroppedLearners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_29671)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E6183B",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_875_29671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7917 10.1562C14.1821 10.1562 12.875 11.4633 12.875 13.0729C12.875 14.6825 14.1821 15.9896 15.7917 15.9896C17.4012 15.9896 18.7083 14.6825 18.7083 13.0729C18.7083 11.4633 17.4012 10.1562 15.7917 10.1562ZM15.7917 10.9896C16.9417 10.9896 17.875 11.9229 17.875 13.0729C17.875 14.2229 16.9417 15.1562 15.7917 15.1562C14.6417 15.1562 13.7083 14.2229 13.7083 13.0729C13.7083 11.9229 14.6417 10.9896 15.7917 10.9896Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7923 20.9948H16.0007C16.2307 20.9948 16.4173 21.1815 16.4173 21.4115C16.4173 21.6415 16.2307 21.8281 16.0007 21.8281H10.3757C10.1457 21.8281 9.95898 21.6415 9.95898 21.4115C9.95898 21.4115 9.95898 21.0677 9.95898 20.5781C9.95898 18.5069 11.6377 16.8281 13.709 16.8281H16.0007C16.2307 16.8281 16.4173 17.0148 16.4173 17.2448C16.4173 17.4748 16.2307 17.6615 16.0007 17.6615H13.709C12.0982 17.6615 10.7923 18.9673 10.7923 20.5781V20.9948Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3349 16.8281C17.8403 16.8281 16.627 18.0415 16.627 19.536C16.627 21.0306 17.8403 22.244 19.3349 22.244C20.8295 22.244 22.0428 21.0306 22.0428 19.536C22.0428 18.0415 20.8295 16.8281 19.3349 16.8281ZM19.3349 17.6615C20.3695 17.6615 21.2095 18.5015 21.2095 19.536C21.2095 20.5706 20.3695 21.4106 19.3349 21.4106C18.3003 21.4106 17.4603 20.5706 17.4603 19.536C17.4603 18.5015 18.3003 17.6615 19.3349 17.6615Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2078 18.9923L19.8736 20.6581C20.0361 20.8206 20.3003 20.8206 20.4628 20.6581C20.6253 20.4956 20.6253 20.2315 20.4628 20.069L18.797 18.4031C18.6345 18.2406 18.3703 18.2406 18.2078 18.4031C18.0453 18.5656 18.0453 18.8298 18.2078 18.9923Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8736 18.4031L18.2078 20.069C18.0453 20.2315 18.0453 20.4956 18.2078 20.6581C18.3703 20.8206 18.6345 20.8206 18.797 20.6581L20.4628 18.9923C20.6253 18.8298 20.6253 18.5656 20.4628 18.4031C20.3003 18.2406 20.0361 18.2406 19.8736 18.4031Z",
    fill: "#EA1F4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_29671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_875_29671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(9.33398 9.32812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroppedLearners);
export default __webpack_public_path__ + "static/media/dropped_learners.b8ef07ee26d84ee6c25058926e570816.svg";
export { ForwardRef as ReactComponent };